<template>
  <Loader :loading="httpSend">
    <div class="row mb-2">
      <div class="col-md-12 text-right">
        <b-button v-b-modal.modal-new-socio variant="dark">Novo Sócio</b-button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h6 v-show="list_socio && list_socio.length < 1" class="text-danger">Necessário informar pelo menos um
          sócio</h6>
        <div v-show="list_socio && list_socio.length > 0" class="table-responsive">
          <table class="table mb-0">
            <thead>
            <tr>
              <th>Nome</th>
              <th>Participação</th>
              <th>Função</th>
              <th>Representante</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="s in list_socio" v-bind:key="s.tms_codigo">
              <td>{{ s.tps_razao_social_nome }}</td>
              <td>{{ s.tms_participacao }}</td>
              <td>{{ s.tms_qualificacao | socioFuncao }}</td>
              <td>{{ s.tms_representante | s_NtoText }}</td>
              <td class="text-right">
                <button type="button" title="Editar" @click="openSocio(s)" class="btn btn-outline-info btn-sm mr-2">
                  <i class="bx bxs-edit"></i></button>
                <button type="button" title="Excluir" @click="deleteSocio(s)" class="btn btn-outline-danger btn-sm">
                  <i class="bx bxs-trash"></i></button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <b-modal
        id="modal-new-socio"
        ref="modal-new-socio"
        size="xl"
        title="Cadastrar Sócio/Administrador"
        title-class="font-18"
        :hide-header-close="true"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true">
      <div class="modal-body">
        <Loader :loading="httpSend">
          <div class="row">
            <div class="col-md-4">
              <b-form-group label="CPF/CNPJ" label-for="tps_cpf_cnpj">
                <the-mask
                    v-model="pessoa.tps_cpf_cnpj"
                    class="form-control"
                    id="tps_cpf_cnpj"
                    v-on:focusout.native="locSocio(pessoa.tps_cpf_cnpj)"
                    :class="{ 'is-invalid': $v.pessoa.tps_cpf_cnpj.$error || cpfCnpjInvalido}"
                    :mask="['###.###.###-##', '##.###.###/####-##']"/>
                <div v-if="$v.pessoa.tps_cpf_cnpj.$error" class="invalid-feedback">
                  Informe CPF ou CNPJ
                </div>
                <div v-if="cpfCnpjInvalido" class="invalid-feedback">
                  CPF ou CNPJ inválido
                </div>
              </b-form-group>
            </div>
            <div class="col-md-8">
              <b-form-group label="Nome Completo/Razão Social" label-for="tps_razao_social_nome">
                <input class="form-control" v-model="pessoa.tps_razao_social_nome"
                       :class="{ 'is-invalid': $v.pessoa.tps_razao_social_nome.$error }"
                       id="tps_razao_social_nome" type="text">
                <div v-if="$v.pessoa.tps_razao_social_nome.$error" class="invalid-feedback">
                  Informe seu nome completo ou razão social
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <b-form-group label="E-mail" label-for="tps_mail">
                <input class="form-control" v-model="pessoa.tps_mail"
                       :class="{ 'is-invalid': $v.pessoa.tps_mail.$error }"
                       ref="tps_mail"
                       id="tps_mail" type="email">
                <div v-if="$v.pessoa.tps_mail.$error" class="invalid-feedback">
                  Informe o e-mail
                </div>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Celular" label-for="tet_codigo_celular">
                <input class="form-control" v-model="pessoa.tet_codigo_celular"
                       v-mask="'(##) ##### - ####'"
                       :class="{ 'is-invalid': $v.pessoa.tet_codigo_celular.$error }"
                       ref="tet_codigo_celular"
                       id="tet_codigo_celular" type="text">
                <div v-if="$v.pessoa.tet_codigo_celular.$error" class="invalid-feedback">
                  Informe um telefone celular
                </div>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Tel. Comercial" label-for="tet_codigo_comercial">
                <input class="form-control" v-model="pessoa.tet_codigo_comercial"
                       v-mask="'(##) #### - ####?#'"
                       :class="{ 'is-invalid': $v.pessoa.tet_codigo_comercial.$error }"
                       id="tet_codigo_comercial" type="text">
                <div v-if="$v.pessoa.tet_codigo_comercial.$error" class="invalid-feedback">
                  Informe um telefone comercial
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <b-form ref="formEnd">
                <div class="row">
                  <div class="col-md-3">
                    <b-form-group
                        id="cep-group"
                        label="CEP"
                        label-for="cep-reply">
                      <input
                          id="cep-reply"
                          ref="ted_cep"
                          v-model="pessoa.ted_cep"
                          v-on:focusout="locCEP(pessoa.ted_cep)"
                          v-mask="'##.###-###'"
                          type="text"
                          maxlength="20"
                          class="form-control"
                          placeholder=" "
                          :class="{'is-invalid': errorCep || (submitted && $v.pessoa.ted_cep.$error)}">
                      <div v-show="$v.pessoa.ted_cep.$error" class="invalid-feedback">
                        Informe um CEP
                      </div>
                      <div v-show="errorCep" class="invalid-feedback">
                        CEP não encontrado
                      </div>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group
                        id="cidade-group"
                        label="Cidade - UF"
                        label-for="cidade">
                      <h5 v-if="pessoa.mun_nome" class="mb-3 mt-3">{{ pessoa.mun_nome }} -
                        {{ pessoa.mun_uf }}</h5>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <b-form-group
                        id="quadra-group"
                        label="Endereço/Quadra"
                        label-for="quadra">
                      <input
                          id="quadra"
                          ref="ted_logradouro"
                          v-model="pessoa.ted_logradouro"
                          type="text"
                          maxlength="200"
                          class="form-control"
                          placeholder=" "
                          :class="{'is-invalid': submitted && $v.pessoa.ted_logradouro.$error,}">
                      <div v-show="$v.pessoa.ted_logradouro.$error" class="invalid-feedback">
                        Informe seu endereço
                      </div>
                    </b-form-group>
                  </div>
                  <div class="col-md-3">
                    <b-form-group
                        id="lote-group"
                        label="Número/Lote"
                        label-for="lote">
                      <input
                          id="lote"
                          ref="ted_numero"
                          v-model="pessoa.ted_numero"
                          type="text"
                          maxlength="10"
                          class="form-control"
                          placeholder=" "
                          :class="{'is-invalid': submitted && $v.pessoa.ted_numero.$error,}">
                      <div v-show="$v.pessoa.ted_numero.$error" class="invalid-feedback">
                        Seu Número
                      </div>
                    </b-form-group>
                  </div>
                  <div class="col-md-5">
                    <b-form-group
                        id="bairro-group"
                        label="Bairro"
                        label-for="cep-reply">
                      <input
                          id="bairro"
                          v-model="pessoa.ted_bairro"
                          type="text"
                          maxlength="100"
                          class="form-control"
                          placeholder=" "
                          :class="{'is-invalid': submitted && $v.pessoa.ted_bairro.$error,}">
                      <div v-show="$v.pessoa.ted_bairro.$error" class="invalid-feedback">
                        Informe o bairro
                      </div>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <b-form-group
                        id="complemento-group"
                        label="Complemento"
                        label-for="complemento">
                      <input
                          id="complemento"
                          v-model="pessoa.ted_complemento"
                          type="text"
                          maxlength="100"
                          class="form-control"
                          placeholder=" ">
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group
                        id="group-ted_ponto_referencia"
                        label="Ponto de Referência"
                        label-for="ted_ponto_referencia">
                      <input
                          id="ted_ponto_referencia"
                          v-model="pessoa.ted_ponto_referencia"
                          type="text"
                          maxlength="100"
                          class="form-control"
                          placeholder=" ">
                    </b-form-group>
                  </div>
                </div>
              </b-form>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <b-form-group label="Função" label-for="tms_qualificacao">
                <select id="tms_qualificacao" v-model="pessoa.tms_qualificacao" class="custom-select"
                        :class="{ 'is-invalid': $v.pessoa.tms_qualificacao.$error }"
                        type="text">
                  <option v-for="q in qualificadores" v-bind:value="q.tab_codigo" v-bind:key="q.tab_codigo">
                    {{ q.tab_nome }}
                  </option>
                </select>
                <div v-if="$v.pessoa.tms_qualificacao.$error" class="invalid-feedback">
                  Informe função do sócio
                </div>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Participação" label-for="tms_participacao">
                <money class="form-control"
                       id="tms_participacao"
                       v-model="pessoa.tms_participacao" v-bind="money"></money>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="'" class="text-white mt-2" label-for="tms_representante">
                <b-form-checkbox
                    id="tms_representante"
                    v-model="pessoa.tms_representante"
                    :unchecked-value="false"
                    class="custom-checkbox text-dark custom-checkbox-outline custom-checkbox-primary mb-3">
                  Representante Legal
                </b-form-checkbox>
              </b-form-group>
            </div>
          </div>
        </Loader>
      </div>
      <template #modal-footer="{ ok, cancel}">
        <b-button variant="success" @click="saveSocio">
          {{ pessoa.tps_codigo ? 'Atualizar sócio' : 'Incluir sócio' }}
        </b-button>
        <b-button variant="danger" @click="closeModal('modal-new-socio')">
          Cancelar
        </b-button>
      </template>
    </b-modal>
  </Loader>
</template>
<script>
import {Money} from 'v-money'
import {TheMask} from 'vue-the-mask'
import {required} from "vuelidate/lib/validators";
import Loader from "@/components/widgets/loader"
import funcaoSocio from "@/dados/funcao-socio.json";
import {getCEP} from "@/api/externa/cep"
import {getSocio} from "@/api/core/pessoa";
import {deleteCecSetSocio, listSocios, setCecSetSocio} from "@/api/solicitacao/pessoa";
import Swal from "sweetalert2";
import {validaCpfCnpj} from "@/helps/util";

export default {
  components: {
    Loader,
    Money,
    TheMask
  },
  props: {
    list_socio: {
      type: Array,
    },
    qualificadores: {
      type: Array,
    },
    ecomonico: {
      type: Object,
    },
  },
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '%',
        precision: 2
      },
      pessoa: {
        pes_codigo: null,
        tps_codigo: null,
        ted_codigo: null,
        tps_cpf_cnpj: "",
        tps_razao_social_nome: "",
        tet_codigo_celular: "",
        tet_codigo_comercial: "",
        tps_mail: "",
        tms_qualificacao: "",
        tms_participacao: 0.00,
        tms_representante: false,
        ted_tipo: "907",
        ted_cep: "",
        ted_logradouro: "",
        ted_bairro: "",
        ted_numero: "",
        ted_complemento: "",
        ted_ponto_referencia: "",
        mun_codigo: null,
        mun_uf: "",
        mun_nome: "",
      },
      socios: [],
      errorCep: false,
      submitted: false,
      httpSend: false,
      cpfCnpjInvalido: false,
    };
  },
  validations: {
    pessoa: {
      tps_cpf_cnpj: {
        required
      },
      tps_razao_social_nome: {
        required,
      },
      tet_codigo_celular: {
        required,
      },
      tet_codigo_comercial: {
        required,
      },
      tps_mail: {
        required,
      },
      tms_qualificacao: {
        required,
      },
      ted_tipo: {
        required
      },
      ted_cep: {
        required
      },
      ted_bairro: {
        required,
      },
      ted_numero: {
        required,
      },
      ted_logradouro: {
        required,
      },
    },
  },
  computed: {
    funcao() {
      return funcaoSocio;
    }
  },
  methods: {
    pessoaReset() {
      return {
        pes_codigo: null,
        tps_codigo: null,
        ted_codigo: null,
        tps_cpf_cnpj: "",
        tps_razao_social_nome: "",
        tet_codigo_celular: "",
        tet_codigo_comercial: "",
        tps_mail: "",
        tms_qualificacao: "",
        tms_participacao: 0.00,
        tms_representante: false,
        ted_tipo: "907",
        ted_cep: "",
        ted_logradouro: "",
        ted_bairro: "",
        ted_numero: "",
        ted_complemento: "",
        ted_ponto_referencia: "",
        mun_codigo: null,
        mun_uf: "",
        mun_nome: "",
      }
    },
    resetAll() {
      this.pessoa = this.pessoaReset();
    },
    getSocios() {
      this.httpSend = true
      listSocios(this.ecomonico.tec_codigo).then(result => {
        if (result.status) {
          this.$emit('update:list_socio', result.dados.socio)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false
      })
    },
    locSocio(cpfcnpj) {
      this.cpfCnpjInvalido = false;
      if (!cpfcnpj) {
        return
      }
      if (validaCpfCnpj(this.pessoa.tps_cpf_cnpj)) {
        this.httpSend = true;
        getSocio({pes_cpfcnpj: cpfcnpj}).then(result => {
          this.pessoa.pes_codigo = null;
          this.pessoa.tps_codigo = null;
          this.pessoa.tps_razao_social_nome = null;
          this.pessoa.tps_mail = null;
          if (result.status) {
            if (result.dados.pes_codigo) {
              this.pessoa.pes_codigo = result.dados.pes_codigo
            }
            if (result.dados.tps_codigo) {
              this.pessoa.tps_codigo = result.dados.tps_codigo
            }
            this.pessoa.tps_razao_social_nome = result.dados.nome
            this.pessoa.tps_mail = result.dados.mail;
            this.pessoa.tet_codigo_celular = result.dados.tet_codigo_celular;
            this.pessoa.tet_codigo_comercial = result.dados.tet_codigo_comercial;
            this.pessoa.ted_cep = result.dados.ted_cep;
            this.pessoa.ted_logradouro = result.dados.ted_logradouro;
            this.pessoa.ted_numero = result.dados.ted_numero;
            this.pessoa.ted_bairro = result.dados.ted_bairro;
            this.pessoa.ted_complemento = result.dados.ted_complemento;
            this.pessoa.ted_ponto_referencia = result.dados.ted_ponto_referencia;
            this.pessoa.mun_codigo = result.dados.mun_codigo;
            this.pessoa.mun_nome = result.dados.mun_nome;
            this.pessoa.mun_uf = result.dados.mun_uf;
            if (this.pessoa.tps_mail) {
              this.$refs.tet_codigo_celular.focus();
            } else {
              this.$refs.tps_mail.focus();
            }
          }
        }).catch(error => {
          console.log(error)
        }).finally(() => {
          this.httpSend = false
        })
      } else {
        this.cpfCnpjInvalido = true;
        return
      }
    },
    locCEP(cep) {
      if (!cep) {
        return
      }
      this.httpSend = true;
      this.errorCep = false;
      getCEP(cep).then(result => {
        if (result.status === 200) {
          if (Object.prototype.hasOwnProperty.call(result.data, 'erro')) {
            this.$refs.ted_cep.focus();
            this.errorCep = true;
            this.pessoa.mun_uf = '';
            this.pessoa.mun_nome = '';
            this.pessoa.mun_codigo = null;
            this.pessoa.ted_bairro = '';
            this.pessoa.ted_logradouro = '';
          } else {
            this.errorCep = false;
            this.pessoa.mun_uf = result.data.uf;
            this.pessoa.mun_nome = result.data.localidade;
            this.pessoa.mun_codigo = result.data.ibge;
            this.pessoa.ted_bairro = result.data.bairro;
            this.pessoa.ted_logradouro = result.data.logradouro;
            if (this.pessoa.ted_logradouro) {
              this.$refs.ted_numero.focus();
            } else {
              this.$refs.ted_logradouro.focus()
            }
          }
        }
      }).catch(error => {
        console.log(error)
        this.errorCep = false;
      }).finally(() => {
        this.httpSend = false
      })
    },
    saveSocio() {
      this.submitted = true;
      this.cpfCnpjInvalido = false;
      this.$v.$touch();
      if (this.$v.pessoa.$invalid) {
        return false;
      }
      if (validaCpfCnpj(this.pessoa.tps_cpf_cnpj)) {
        this.httpSend = true;
        setCecSetSocio({ecomonico: this.ecomonico, socio: this.pessoa}).then(response => {
          if (response.status) {
            this.getSocios();
            this.$refs['modal-new-socio'].hide();
            this.resetAll();
            this.submitted = false;
          } else {
            this.$toast.error(response.mensagem);
          }
        }).catch(error => {
          console.log(error)
        }).finally(() => {
          this.httpSend = false
        })
      } else {
        this.cpfCnpjInvalido = true;
        return false;
      }
    },
    openSocio(socio) {
      socio.telefone.forEach(function (t) {
        if (t.tet_codigo.tab_numero === 1) {
          socio.tet_codigo_celular = t.tfo_numero;
          socio.tfo_codigo_celular = t.tfo_codigo;
        }
        if (t.tet_codigo.tab_numero === 2) {
          socio.tet_codigo_comercial = t.tfo_numero;
          socio.tfo_codigo_comercial = t.tfo_codigo;
        }
      });
      socio.tms_representante = (socio.tms_representante === 'S')
      this.pessoa = socio;
      this.$refs['modal-new-socio'].show();
    },
    closeModal(ref) {
      this.$refs[ref].hide();
      this.resetAll();
    },
    deleteSocio(socio) {
      Swal.fire({
        title: "Excluir sócio?",
        html: `Deseja realmente excluir o sócio <b>${socio.tps_razao_social_nome}</b>`,
        text: ``,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f47a78",
        cancelButtonColor: "#100e0e",
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      }).then(result => {
        if (result.isConfirmed) {
          this.httpSend = true;
          deleteCecSetSocio(socio.tms_codigo).then(response => {
            if (response.status) {
              this.getSocios();
            } else {
              this.$toast.error(response.mensagem);
            }
          }).catch(error => {
            console.log(error)
          }).finally(() => {
            this.httpSend = false
          })
        } else {
          return false;
        }
      });
    },
  },
  filters: {
    socioFuncao: function (codigo) {
      let funcao = funcaoSocio.filter(f => parseInt(f.codigo) === parseInt(codigo));
      return funcao[0].descricao
    }
  },
};
</script>